import styled from 'styled-components';

import { fontFamilySize, px } from '../../../contrib/ui';

export const HandicapAllowanceStyled = styled.div`
  .handicap-header-info {
    color: var(--grey9b);
    font-family: 'DINNextLTPro-Medium';
    font-size: ${px(14)};
    height: ${px(36)};
  }
  .event-handicap-input {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .handicap-slider {
      padding-right: ${px(20)};
      z-index: 0;
    }

    .input-form-control {
      width: 25%;

      .material-input {
        margin: 0;
        ${fontFamilySize('Heavy', 30)}

        input {
          text-align: right;
        }

        &::after {
          ${fontFamilySize('Heavy', 30)}

          position: relative;
          top: 0.05em;
          color: var(--dark);
          content: '%';
          display: block;
          line-height: 1;
        }

        p {
          display: none;
        }
      }
    }
  }
`;
